import React from 'react';
import styled from '@emotion/styled';
import { Dialog, DialogContent, Box } from '@mui/material';

import { ButtonIcon } from '../styledComponent/Buttons.style';

import { getColor } from './UICommon';
import { MainFunnelButton } from './MainFunnelButton';
import { TitleAndDescriptionProps } from './BaseStep';

import closeIcon from '../../assets/closeIcon.svg';

const PopUpDialog = styled(Dialog)`
  margin: 0;
  height: 100vh;
  width: 100vw;
  background-color: ${getColor('WHITE')};
`;

const PopUpContent = styled(DialogContent)`
  padding: 0;
  width: 100%;
`;

const PopUpBox = styled(Box)`
  max-width: 444px;
  margin: 0 auto;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

const Padding = styled.div`
  padding: 32px 32px 0 32px;
`;

export interface ButtonSection extends TitleAndDescriptionProps {
  ctaButtonTitle: string;
}

interface FacilitatorInformationPopUpProps {
  open: boolean;
  children?: React.ReactNode;
  onClose: () => void;
  onClick?: () => void;
  buttonSection?: ButtonSection;
  isButtonDisabled?: boolean;
}

export const FacilitatorInformationPopUp = (props: FacilitatorInformationPopUpProps) => {
  const { buttonSection, onClick, open, children, onClose, isButtonDisabled = false } = props;

  const renderButton = () => {
    if (onClick && buttonSection) {
      return (
        <MainFunnelButton
          id="cta_FacilitatorInformationPopUp"
          text={buttonSection.ctaButtonTitle}
          paymentInformation={buttonSection}
          onClick={onClick}
          disabled={isButtonDisabled}
        />
      );
    }
  };

  return (
    <PopUpDialog onClose={onClose} open={open} fullScreen>
      <PopUpContent>
        <PopUpBox>
          <Padding>
            <ButtonIcon onClick={onClose}>
              <img src={closeIcon} alt="close" />
            </ButtonIcon>
          </Padding>

          {children}
        </PopUpBox>

        {renderButton()}
      </PopUpContent>
    </PopUpDialog>
  );
};
